<template>
    <div class="journal-entry-container">

        <div class="journal__subheader d-flex align-items-center justify-content-between mb-3">
            <div class="header-container m-bottom-2rem">
                <span>Manual Journal Entry Report</span>
            </div>
            <template v-if="isEnableSave">
                <el-button v-if="!isLoadingSave" type="peiso-primary-pink" @click="saveJournalEntry">Save journal entry</el-button>
                <el-button v-if="isLoadingSave" type="peiso-primary-pink"><i class="el-icon-loading"></i> Saving journal...</el-button>
            </template>
        </div>

        <div v-if="!isLoading">
            <div v-for="(journal, i) in journals" :key="i" class="journal__body--container">
                <div class="journal__wrapper">
                    <div class="report mx-5 m-bottom-10 d-flex gap-10 align-items-center justify-content-between">
                        <span>
                            Report Status:
                            <span :class="{green : journal.status == 'POSTED', red : journal.status != 'POSTED'}">{{ journal.status }}</span>
                        </span>
                        <span>Report Date: {{ journal.date }}</span>
                    </div>

                    <div class="journal__top">
                        <div class="mx-5 w-full mb-4">
                          <label class="journal__label" for="">Narration</label>
                          <el-input v-model="journal.narration" class="journal__input peiso-input-default h-45" :class="{'is-error' : !$box.checkValueExists(journal.narration)}" placeholder="Narration"></el-input>
                        </div>
                       <div class="d-flex gap-10 mt-4">
                          <div class="mx-5 w-full">
                              <label class="journal__label" for="">Line Amount Type</label>
                              <el-input v-model="journal.lineAmountTypes" class="journal__input peiso-input-default h-45" :class="{'is-error' : !$box.checkValueExists(journal.lineAmountTypes)}" placeholder="Line Amount Type"></el-input>
                          </div>
                          <!-- <div class="mx-5 w-full">
                              <label class="journal__label" for="">Accommodation Revenue</label>
                              <el-input v-model="journal.accommodationRevenue" v-mask="currencyMask" class="journal__input peiso-input-default h-45"></el-input>
                          </div> -->
                       </div>
                    </div>

                    <div class="journal__body">
                        <span class="d-block p-10-all">Journal Lines List</span>

                        <div class="journal__list head-label d-flex gap-5 m-bottom-5">
                            <div class="text-center w-full mx-5">Description</div>
                            <div class="text-center w-full mx-5">Tender</div>
                            <!-- <div class="text-center w-full mx-5">Accounts</div> -->
                            <div class="text-center w-full mx-5">Tax Rate</div>
                            <div style="max-width: 130px;" class="text-center w-full mx-5">Jobs</div>
                            <div style="max-width: 130px;" class="text-center w-full mx-5">Area</div>
                            <div style="max-width: 130px;" class="text-center w-full mx-5">Debit</div>
                            <div style="max-width: 130px;" class="text-center w-full mx-5">Credit</div>
                        </div>
                        <div class="journal__list d-flex gap-5 m-bottom-5" v-for="(item, j) in journal.journalLines" :key="`${j}`">

                            <!-- <div class="btn-cont" style="min-width: 100px; max-width: 100px;">
                                <el-button type="peiso-danger" class="w-100" @click="removeJournalEntry(i, j)">Remove</el-button>
                            </div> -->

                            <!-- <el-input v-model="item.description" class="peiso-input-default h-45 mx-5 w-100" :class="{'is-error' : !$box.checkValueExists(item.description)}" placeholder="Description"></el-input> -->
                            <el-input v-model="item.remarks" class="peiso-input-default h-45 mx-5 w-100" :class="{'is-error' : !$box.checkValueExists(item.remarks)}" placeholder="Description"></el-input>

                            <el-select v-model="item.code" filterable placeholder="Select" class="peiso-select-default h-45 w-100">
                                <el-option v-for="(item, i) in options" :key="`code-${i}`" :label="item.label" :value="item.value"/>
                            </el-select>
                            <!-- <el-input v-model="item.remarks" class="peiso-input-default h-45 mx-5 w-100" :class="{'is-error' : !$box.checkValueExists(item.remarks)}" placeholder="Journal line remarks"></el-input> -->
                            <el-input :value="item.gstType" class="peiso-input-default h-45 mx-5 w-100" :class="{'is-error' : !$box.checkValueExists(item.gstType)}" placeholder="GST"></el-input>
                            <el-input class="peiso-input-default h-45 mx-5 w-100" style="max-width: 130px;"></el-input>
                            <el-input class="peiso-input-default h-45 mx-5 w-100" style="max-width: 130px;"></el-input>
                            <el-input v-model="item.debit" :disabled="item.isCredit" v-mask="unsignedCurrencyMask" class="peiso-input-default h-45 right-align mx-5" @change="totalAmout(form.list)" :class="{'is-error' : !$box.checkValueExists(item.debit) && !$box.checkValueExists(item.credit)}" placeholder="" style="max-width: 130px;"></el-input>
                            <el-input v-model="item.credit" :disabled="!item.isCredit" v-mask="currencyMask" class="peiso-input-default h-45 right-align mx-5" @change="totalAmout(form.list)" :class="{'is-error' : !$box.checkValueExists(item.debit) && !$box.checkValueExists(item.credit)}" placeholder="" style="max-width: 130px;"></el-input>
                        </div>


                        <!-- <div class="journal__list d-flex gap-5 m-bottom-5">
                            <div class="btn-cont" style="min-width: 100px; max-width: 100px;">
                                <el-button type="peiso-success" class="w-100" @click="addJournalEntry(i)" :disabled="code == '' || remarks == '' || total == ''">Add</el-button>
                            </div>
                            <el-input v-model="code" class="peiso-input-default h-45 center-align mx-5" :class="{'is-error' : !$box.checkValueExists(code)}" placeholder="000" style="max-width: 120px;"></el-input>
                            <el-input v-model="remarks" class="peiso-input-default h-45 mx-5 w-100" :class="{'is-error' : !$box.checkValueExists(remarks)}" placeholder="Journal line remarks"></el-input>
                            <el-input v-model="total" type="number" class="peiso-input-default h-45 right-align mx-5" :class="{'is-error' : !$box.checkValueExists(total)}" placeholder="0.00" style="max-width: 130px;"></el-input>
                        </div> -->

                    </div>
                </div>
            </div>

            <div class="journal__list journal__button d-none justify-content-center gap-10 mt-5">
                <div class="btn-cont" style="min-width: 200px; max-width: 200px;">
                    <el-button type="peiso-primary-pink" class="w-100" @click="save">Save entry</el-button>
                </div>
                <!-- <el-input class="peiso-input-default h-45 right-align m-5-10" :value="form.total | vMask(currencyMask)" placeholder="0.00" style="max-width: 150px;"></el-input> -->
            </div>
        </div>
        <div v-else class="journal__empty d-flex justify-content-center align-items-center text-center">

            <i class="el-icon-loading s-50 white"></i>
        </div>

    </div>
</template>

<style lang="scss" scoped>
@import 'static/scss/colors';
@import 'static/scss/fonts/fonts';
    .journal-entry-container {
        min-height: 500px;
        .mb-4 {
          margin-bottom: 15px;
        }
        .w-full {
            width: 100% !important;
        }
        .journal__top {

        }
        .journal__wrapper {
            padding: 10px;
            border: 1px solid $gray8;
        }

        .journal__button {
            margin-top: 20px;
        }

        .journal__label {
            padding: 10px 0px;
            @include montserrat-font(13px, 153.9%, 500, $white);
        }

        .journal__empty {
            padding: 40px 0px;
            h4 {
                @include montserrat-font(16px, 153.9%, 700, #ffffff81);
            }
        }

        .journal__subheader {
            margin-bottom: 10px;
            position: sticky;
            top: -2rem;
            z-index: 10;
            padding-bottom: 1rem;
            background-color: $gray2;
        }

        .journal__input  {
            margin-top: 10px;
        }

        .journal__body--container {
            padding: 10px 0px;
        }

        .journal__body {
            //padding: 10px;
            > span {
                @include montserrat-font(16px, 153.9%, 700, $white);
            }

            .journal__list {

                &.head-label {
                    @include montserrat-font(14px, 153.9%, 500, $white);
                }

                .btn-cont {
                    width: 100px;
                    display: flex;
                    align-items: center;
                }
            }

            .head__button{
                .el-button {
                    font-weight: 500 !important;

                }
            }
        }

        .is-error {
            border-radius: 4px;
        }

        .report {
            span {

                @include montserrat-font(16px, 153.9%, 700, $white);
            }
        }

        .el-button {
            @include montserrat-font(16px, normal, 400, $white) {
            }
        }

        .head__button {
        }
    }
</style>

<script>
import utils from '@/utils/utils';
import _ from 'lodash'
import Vue from 'vue'
import VueMask from 'v-mask'
Vue.use(VueMask)
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import Api from "../../api/api";
export default {
    data() {
        return {
            form: {
                lineAmount: '',
                narration: '',
                accommodationRevenue:'0',
                list: [],
                total: ''
            },
            code: '',
            remarks: '',
            total: '',
            journals: [],
            currencyMask: createNumberMask({
                prefix: '$',
                allowDecimal: true,
                includeThousandsSeparator: true,
                allowNegative: true,
            }),
            unsignedCurrencyMask: createNumberMask({
                prefix: '$',
                allowDecimal: true,
                includeThousandsSeparator: true,
                allowNegative: false,
            }),
            isLoadingSave: false,
            isEnableSave: false,
            isLoading: false,
            options: [],

        }
    },
    props: {
        isOpen: {
            default: false
        },

        reportDate: {
            default: null
        }
    },
    watch: {
        async isOpen(val) {
            if (val) {
                this.isLoading = true;
                await this.xeroAccountList()
                this.journals = []
                this.journalEntry()
            }
        }
    },

    methods: {
        addJournalEntry(index) {
            var data = {
                code: this.code,
                remarks: this.remarks,
                total: this.total,
            }

            this.journals[index].list.push(data)
            this.total = ''
            this.remarks = ''
            this.code = ''

            this.form.total = this.totalAmout(this.form.list)

        },

        removeJournalEntry(journalIndex, listIndex){
            this.journals[journalIndex].list = this.journals[journalIndex].list.filter((item, i) => i != listIndex);
        },

        addNewJournalEntry(journalIndex) {
            this.journals[journalIndex].list.push({
                code: '',
                remarks: '',
                debit: '',
                credit: '',
            })
        },

        totalAmout(list) {
            var dataList = list.map((res) => {
                var data = parseFloat(utils.removeCurrencySymbol(res.total)) ? parseFloat(utils.removeCurrencySymbol(res.total)) : 0

                return data
            })

            var totalOverAll = dataList.reduce((a, b) => {
                return a + b
            }, 0)

            return totalOverAll
        },
        save() {
            utils.alert2('', 'You successfully saved data.', 'success');
            this.$emit('close-modal');
        },

        async journalEntry() {
            this.isLoading = true
            if (this.reportDate) {
                const res = await Api.xeroJournal({date: this.reportDate});
                if (res.data && res.data.code == 0) {
                    this.isEnableSave = true
                    this.journals = res.data.data.map(item => {

                        var lists = item.journalLines.map(dat => {

                            var gstType = ''

                            if (dat.taxType == 'INPUT' || dat.taxType == 'OUTPUT') {
                                gstType = 'GST on Income'
                            } else if (dat.taxType == 'BASEXCLUDED') {
                                gstType = 'BAS Excluded'
                            } else if (dat.taxType == 'EXEMPTEXPENSES') {
                                gstType = 'GST Free Income'
                            }

                            var data = {
                                gstType: gstType,
                                code: dat.accountCode,
                                description: dat.accountDescription,
                                remarks: dat.description,
                                debit: parseFloat(dat.lineAmount) >= 0 ? `${utils.formatMoney5(parseFloat(dat.lineAmount))}` : '',
                                credit: parseFloat(dat.lineAmount) < 0 ? `${utils.formatMoney5(parseFloat(dat.lineAmount))}` : '',
                                isCredit: parseFloat(dat.lineAmount) < 0 ? true : false,
                                taxType: dat.taxType
                            }

                            return data
                        })

                        return {
                            date: item.date,
                            status: item.status,
                            lineAmountTypes: item.lineAmountTypes,
                            narration: item.narration,
                            accommodationRevenue:  parseFloat(item.accommodationRevenue) >= 0 ? `${utils.formatMoney5(parseFloat(item.accommodationRevenue))}` : '',
                            total: '',
                            journalLines: lists,
                            periodId: item.periodId
                        }
                    })
                } else {
                    this.isEnableSave = false
                    this.journals = [
                        {
                            date: "2024-08-03",
                            status: "POSTED",
                            lineAmountTypes: "Inclusive",
                            narration: "Manual Entry for 11070",
                            periodId: 11070,
                            journalLines: [
                                {
                                    gstType: "GST on Income",
                                    code: '300',
                                    description: '',
                                    remarks: "Cash Sales - Bar and Restaurant",
                                    debit: '',
                                    credit: 0,
                                    isCredit: true,
                                    taxType: "EXEMPTEXPENSES",
                                },
                                {
                                    gstType: "GST Free Income",
                                    code: '300',
                                    description: "",
                                    remarks: 'Cash Sales - Bar and Restaurant',
                                    debit: '',
                                    credit: 0,
                                    isCredit: true,
                                    taxType: "INPUT",
                                },
                                {
                                    gstType: "GST on Income",
                                    code: '300',
                                    description: '',
                                    remarks: "Cash Sales - Bottle Shop Sales",
                                    debit: '',
                                    credit: 0,
                                    isCredit: true,
                                    taxType: "EXEMPTEXPENSES",
                                },
                                {
                                    gstType: "GST Free Income",
                                    code: '300',
                                    description: "",
                                    remarks: 'Cash Sales - Bottle Shop Sales',
                                    debit: '',
                                    credit: 0,
                                    isCredit: true,
                                    taxType: "INPUT",
                                },
                                {
                                    gstType: "GST on Income",
                                    code: '300',
                                    description: '',
                                    remarks: "Account Sales - Bottle Shop Sales",
                                    debit: '',
                                    credit: 0,
                                    isCredit: true,
                                    taxType: "EXEMPTEXPENSES",
                                },
                                {
                                    gstType: "GST Free Income",
                                    code: '300',
                                    description: "",
                                    remarks: 'Account Sales - Bottle Shop Sales',
                                    debit: '',
                                    credit: 0,
                                    isCredit: true,
                                    taxType: "INPUT",
                                },
                                {
                                    gstType: "BAS Excluded",
                                    code: '300',
                                    description: '',
                                    remarks: "H&L - EftPOS Clearing",
                                    credit: '',
                                    debit: 0,
                                    isCredit: true,
                                    taxType: "BASEXCLUDED",
                                },
                                {
                                    gstType: "BAS Excluded",
                                    code: '300',
                                    description: "",
                                    remarks: 'H&L - Cash Clearing',
                                    credit: '',
                                    debit: 0,
                                    isCredit: true,
                                    taxType: "BASEXCLUDED",
                                },
                                {
                                    gstType: "BAS Excluded",
                                    code: '300',
                                    description: '',
                                    remarks: "H&L - Amex Clearing",
                                    credit: '',
                                    debit: 0,
                                    isCredit: true,
                                    taxType: "BASEXCLUDED",
                                },
                                {
                                    gstType: "BAS Excluded",
                                    code: '300',
                                    description: "",
                                    remarks: 'Remaining Balance',
                                    credit: '',
                                    debit: 0,
                                    isCredit: true,
                                    taxType: "BASEXCLUDED",
                                },
                            ]
                        }
                    ]
                }

                this.isLoading = false
            }
        },

        saveJournalEntry() {
            this.isLoadingSave =  true
            var journals = this.journals.map((res) => {
                var mappedJournalLines = res.journalLines.map((n) => {
                    var data = {
                        lineAmount: n.isCredit ? parseFloat(utils.removeCurrencySymbol(n.credit)) : parseFloat(utils.removeCurrencySymbol(n.debit)),
                        taxType: n.taxType,
                        accountCode: n.code,
                        description: n.remarks,
                    }
                    return data
                })

                return {
                    descrtiption: res.description,
                    date: res.date,
                    status: res.status,
                    lineAmountTypes: res.lineAmountTypes,
                    accommodationRevenue:  parseFloat(utils.removeCurrencySymbol(res.accommodationRevenue)),
                    narration: res.narration,
                    periodId: res.periodId,
                    journalLines: mappedJournalLines
                }
            })

            Api.saveXeroJournal(journals).then((res) => {
                if (res.data.code == 0) {
                    utils.alert2('', 'Journal entry successfully saved', 'success')
                } else {
                    utils.alert2('', res.data.message, 'error')
                }
                this.isLoadingSave = false
            }).catch(error => {
                if (error.response && error.response.data) {
                    utils.alert2('', error.response.data.message, 'error')
                }
                this.isLoadingSave = false
            });
           
        },

        async xeroAccountList() {
            this.options = []
            const result = await Api.xeroAccountList()
            if (result.data && result.data.code == 0) {
                this.options = result.data.data.map((res) => {
                    return {
                        value: res.code,
                        label: `${res.code} - ${res.name}`
                    }
                })
            }
        }
    },
    async mounted() {
        Promise.all([
            await this.xeroAccountList(),
            this.journalEntry()
        ])
    }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/journalManualEntry.vue